import React from 'react';
import styled from 'styled-components';
import { space, width, borderRadius } from 'styled-system';
import { ProgressBar as BlueprintProgressBar, Classes } from '@blueprintjs/core';

const ProgressBarWrap = styled(BlueprintProgressBar)`
  ${space};
  ${width};
  ${borderRadius};

  &.${Classes.PROGRESS_BAR} {
    height: ${(props) => `${props.height || '8px'}`};
    background-color: ${(props) =>
      props.barBgColor ? props.barBgColor : undefined}; //custom bar background color from prop or default
  }

  &.${Classes.INTENT_PRIMARY} {
    .${Classes.PROGRESS_METER} {
      background: ${(props) =>
        props.barColor
          ? props.barColor
          : props.theme.colors.primary}; //custom bar color from prop or theme primary color
      border-radius: ${(props) => props.borderRadius};
    }
  }
`;

function ProgressBar(props) {
  return <ProgressBarWrap {...props} />;
}

export default ProgressBar;
